import axios from 'axios';
export default {

    GetContent(local) {
        return axios.get(`/teams/${local}`)
    },
    GetTeamMembers(local) {
        return axios.get(`/team-members/${local}`)
    },
}